export const RESET_PASSWORD_CODE_EXPIRED_ERROR = 'resetPasswordCode.expired';
export const LOGIN_SHORT_PASSWORD_ERROR = 'signInRequest.password.Size';
